import React from 'react';
import { Clock, CheckCircle, Users } from 'lucide-react';

const StatsSection = ({ t }) => {
  return (
    <section className="py-8 bg-white border-b">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center">
            <Clock className="h-10 w-10 text-amber-600 mx-auto mb-2" />
            <h3 className="text-2xl font-bold text-gray-900">{t.about_experience || '6+ Years'}</h3>
            <p className="text-gray-600">Professional Practice</p>
          </div>
          <div className="text-center">
            <CheckCircle className="h-10 w-10 text-amber-600 mx-auto mb-2" />
            <h3 className="text-2xl font-bold text-gray-900">{t.about_cases || '500+ Cases'}</h3>
            <p className="text-gray-600">Successfully Managed</p>
          </div>
          <div className="text-center">
            <Users className="h-10 w-10 text-amber-600 mx-auto mb-2" />
            <h3 className="text-2xl font-bold text-gray-900">{t.about_clients || 'Trusted'}</h3>
            <p className="text-gray-600">Satisfied Clients</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
